<template>
  <button :class="{ 'loading': loading }" class="m-button" @click="handleClick" :disabled="loading">
    <span v-if="!loading">{{ buttonText }}</span>
    <span v-else>加载中...</span>
  </button>
</template>

<script>
export default {
  name: "LoadingButton",
  props: {
    buttonText: {
      type: String,
      default: 'Click Me'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    };
  },
  methods: {
    handleClick() {
      if (!this.loading) {
        // 触发自定义的按钮点击事件
        this.$emit('button-click');
      }
    }
  }
};
</script>

<style scoped>
.loading {
  position: relative;
}

.loading:after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(360deg); }
}
</style>
